// ##############################
// // // Forgot password view styles
// #############################

//import { customFont } from "assets/styles/jss/main";
import buttonStyle from 'components/CustomButtons/style/buttonStyle';

const lockScreenPageStyle = {
  ...buttonStyle,
  content: {
    position: 'relative',
    zIndex: '4',
    minHeight: '100vh',
    paddingTop: 80,
    display: 'flex',
    alignItems: 'center',
  },
  customCardClass: {
    margin: '0 auto',
    transform: 'translate3d(0, 0, 0)',
    transition: 'all 300ms linear',
  },
  card: {
    animation: 'slide-down 0.5s',
  },
  customCardAvatarClass: {
    maxWidth: '90px',
    maxHeight: '90px',
    marginTop: '-45px',
  },
  customCardFooterClass: {
    border: 'none',
    paddingTop: '0',
  },
  customCardTitleClass: {
    marginBottom: '40px',
    textTransform: 'uppercase',
    //...customFont
  },
};

export default lockScreenPageStyle;
